import React, { useRef } from "react";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Header from "./templates/header";
import LeftBar from "./templates/left_bar";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../services/api.service";
import { currencyFormatter } from "../common/Utils";
import Loader from "../common/Loader";
import { DataGrid, ToolbarOptions } from "tubular-react";
import {
  AggregateFunctions,
  ColumnDataType,
  ColumnSortDirection,
  createColumn,
} from "tubular-common";

import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment/moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BreadCrumbs from "../common/BreadCrumbs";
function ViewTransactions() {
  const [modalVisible, setModalVisible] = useState(false);
  const [farmerId, setFarmerId] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const merchantInfo = useSelector((state) => state.userCredentials);
  const [loader, showLoader] = useState(false);
  const [data, setTransactions] = useState([]);
  const[transdata, setTrans] =  useState([]);
  const [modalProps, setModalProps] = useState([]);
  const [viewdtl, viewTransaction] = useState(false);
  const [dt__to_err, setdt__to_err] = useState("");
  const [dt__from_err, setdt__from_err] = useState("");
  const [statfrom, setStatFrom] = useState("");
  const [statto, setStatto] = useState("");
  const [disabled_input_fr, setDisabledFr] = useState();
  const [disabled_input_to, setDisabledTo] = useState("disabled-input");
  const [disabled_input_slt, setDisabledSelect] = useState("");
  const [stformat, setStatementFormat] = useState("");
  const firstRender = useRef(true);
  const [rowid, setRowId] = useState('')
  const[steps, setSteps] = useState([{ 'title': 'View Transactions','name':'transactions', 'path': '/transactions', 'current': true }])
  const goToHome = () => {
    navigate("/");
    setModalVisible(false);
  };
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  useEffect(
    (statfrom) => {
      if (firstRender.current) {
        firstRender.current = false; // it's no longer the first render
        return; // skip the code below
      }
      setDisabledTo(formValidation());
    },
    [statfrom, statto, format]
  );

  const formValidation = () => {
    if (statfrom === "") {
      return "disabled-input";
    } else {
      return "";
    }
  };
  const fetchTransactions = () => {
    try {
      let pageIndex = 1;
      let pageSize = 100;
      showLoader(true);
      let uri = `/farmer/transactions?search=&pageIndex=${pageIndex}&pageSize=${pageSize}&merchantCode="${merchantInfo.MerchantID}`;
      ApiService.get(uri).subscribe((res) => {
        if (res.data !== undefined && res.data !== null) {
          let trans = res.data.items;
          setTransactions(tdt(trans));
          showLoader(false);
        } else {
          showLoader(false);
          setError("An error occurred");
        }
      });
    } catch (e) {
      showLoader(false);
      console.log("An error occurred" + e);
    } finally {
    }
  };

  const getTrans = () => {
    try {
      let pageIndex = 1;
      let pageSize = 100;
      showLoader(true);
      let uri = `/farmer/transactions_data?search=&pageIndex=${pageIndex}&pageSize=${pageSize}&merchantCode=${merchantInfo.MerchantID}&terminalId=${merchantInfo.UserID}`;
      ApiService.get(uri).subscribe((res) => {
        if (res.data !== undefined && res.data !== null) {
          let trans = res.data.items;
          setTrans(transDt(trans));
          showLoader(false);
        } else {
          showLoader(false);
          setError("An error occurred");
        }
      });
    } catch (e) {
      showLoader(false);
      console.log("An error occurred" + e);
    } finally {
    }
  };

  useEffect(() => {
    showLoader(true);
    getTrans();
  }, []);

  useEffect(() => {
    if (location.state !== undefined && location.state !== null) {
      setFarmerId(location.state.farmerID);
    }
  }, []);

  const columns = [
    createColumn("id", {
      label: "#",
      aggregate: AggregateFunctions.Count,
      filterable: false,
      searchable: false,
      visible: false,
      isKey: true,
      sortable: true,
      
    }),
    createColumn("transactionDate", {
      label: "Tran. Date",
      dataType: ColumnDataType.String,
      filterable: true,
      searchable: true,
      sortable: true,
    }),
    createColumn("transactionReference", {
      label: "Ref Number",
      aggregate: AggregateFunctions.Count,
      filterable: false,
      searchable: true,
      sortDirection: ColumnSortDirection.Descending,
      sortOrder: 1,
      sortable: true
    }),
    createColumn("farmername", {
      label: "Farmer Name/ID",
      aggregate: AggregateFunctions.Count,
      filterable: false,
      searchable: true,
      sortable: true,
    }),
    createColumn("walletname", {
      label: "Wallet",
      aggregate: AggregateFunctions.Count,
      filterable: false,
      searchable: true,
      sortable: true,
    }),
    createColumn("phonenumber", {
      label: "Phone",
      aggregate: AggregateFunctions.Count,
      filterable: false,
      searchable: true,
      sortable: true,
    }),
    createColumn("transactionAmtTotal", {
      label: "Amount",
      aggregate: AggregateFunctions.Count,
      filterable: true,
      searchable: false,
      sortable: true,
    }),
    createColumn("el", {
      label: "Detail",
      aggregate: AggregateFunctions.Count,
      filterable: false,
      searchable: false,
      sortable: false,
      exportable: false
    }),
   
  ];


  const rowClick = (row) => {
    try {
      showLoader(true);
      let uri = `/farmer/transactionsDetails?reference=${row.id}`;
      ApiService.get(uri).subscribe((res) => {
        if (res.data !== undefined && res.data !== null) {
          setModalProps(res.data)
          setRowId(row.transactionReference)
          viewTransaction(true)
          showLoader(false);
        } else {
          showLoader(false);
          Toaster('error', "Unable to fetch Data");
        }
      });
    } catch (e) {
      showLoader(false);
      Toaster('error', "An error occured");
    } finally {
    }
  };

  const toolbarOptions = new ToolbarOptions({
    advancePagination: false,
    bottomPager: false,
    printButton: false,
    searchText: true,
    exportButton: true,
    topPager: false
  });

  const statementHandler = () => {
    setdt__from_err("");
    setdt__to_err("");
  };

  const genReports = (e) => {
    e.preventDefault();
    if (statfrom === undefined) {
      setdt__from_err("error");
    } else if (statto === undefined) {
      setdt__to_err("error");
    } else {
      exportFile();
    }
  };
  const exportFile = () => {
    let type = stformat ? stformat : "pdf";
    showLoader(true);
    try {
      let payload = {
        merchantCode: merchantInfo.MerchantID,
        terminalId: merchantInfo.UserID,
        fromDate: format(new Date(startDate), "yyyy-MM-dd hh:mm:ss"),
        toDate: format(new Date(endDate), "yyyy-MM-dd hh:mm:ss"),
        type: stformat ? stformat : "pdf",
      };
      ApiService.file("/farmer/transaction/report", payload).subscribe(
        (res) => {
          if (res.data !== undefined && res.data !== null) {
            showLoader(false);
            if (type == "pdf") {
              let blob;
              var arrBuffer = res.data;
              blob = new Blob([arrBuffer], { type: "application/pdf" });
              const downloadURL = window.URL.createObjectURL(blob);
              window.open(downloadURL);
            } else if (type == "excel") {
              const url = URL.createObjectURL(
                new Blob([res.data], { type: "application/vnd.ms-excel" })
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `STATEMENT_ ${merchantInfo.MerchantID}` + ".xlsx"
              );
              document.body.appendChild(link);
              link.click();
            } else {
              this.csvprocessing = false;
            }
          } else {
            showLoader(false);
            Toaster('error', "No Records found");
          }
        }
      );
    } catch (e) {
      showLoader(false);
      console.log("An error occurred" + e);
    } finally {
    }
  };

  const exportReceipt = (a) => {
    let type = "pdf";
    showLoader(true);
    try {
      let payload = {
        reference: a
      };
      ApiService.file("/farmer/transactionsDetails/report", payload).subscribe(
        (res) => {
          if (res.data !== undefined && res.data !== null) {
            showLoader(false);
            if (type == "pdf") {
              let blob;
              var arrBuffer = res.data;
              blob = new Blob([arrBuffer], { type: "application/pdf" });
              const downloadURL = window.URL.createObjectURL(blob);
              window.open(downloadURL);
            } 
          } else {
            showLoader(false);
            Toaster('error', "Unable to get Report");
          }
        }
      );
    } catch (e) {
      showLoader(false);
      console.log("An error occurred" + e);
    } finally {
    }
  };
  return (
    <div className="home_landing">
      {/* render header */}
      <Header />
      <div className={`home_app ${viewdtl ? `is-blurred` : ""}`}>
        {/* render left menu bar */}
        <LeftBar />

        <div className="home_data_template_preset view-trans">
          <Loader loader={loader} />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            />
            {/* Same as */}
          <ToastContainer />
          <div className="summary">
            <div className="summary_wrapper">
              <div className="summary_wrapper_selected_products_container">
                <div className="view-transactions-heading">
                </div>
                <div className="view-transaction-wrapper">
                <BreadCrumbs steps={steps}></BreadCrumbs>
                <h3 className="verify_wrapper_heading">
                  View Transactions
                  </h3>
                  <div className="form-inputs search-box mobile-view">
                    <DateRangePicker
                      startDate={startDate}
                      startDateId="s_id"
                      endDate={endDate}
                      endDateId="e_id"
                      onDatesChange={({ startDate, endDate }) => {
                        setStartDate(startDate);
                        setEndDate(endDate);
                      }}
                      focusedInput={focusedInput}
                      onFocusChange={(e) => setFocusedInput(e)}
                      displayFormat="DD/MM/YYYY"
                      isOutsideRange={(day) => moment().diff(day) < 0}
                    />

                    <div
                      className="input-group"
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <select
                        className={`input-select select-export-format ${disabled_input_slt}`}
                        onChange={(e) => {
                          setStatementFormat(
                            e.target.options[e.target.selectedIndex].value
                          );
                        }}
                      >
                        <option>Statement Format </option>
                        <option value="pdf">PDF </option>
                        <option value="excel">Excel </option>
                      </select>
                      <div className="input-select_arrow"></div>
                    </div>

                    <div
                      className="input-group"
                      style={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <button
                        className={`input form-btn generate-report pr-btn ${endDate ? '' : 'disabled-input'}`}
                        onClick={(e) => {
                          e.preventDefault();
                          exportFile(e);
                        }}
                      >
                        Generate Report
                      </button>
                    </div>
                  </div>

                  <DataGrid
                    gridName="KCEP Transactions Reports"
                    columns={columns}
                    dataSource={transdata}
                    mobileBreakpointWidth={100}
                    onRowClick={rowClick}
                    toolbarOptions={toolbarOptions}
                    LocalStorage={true}
                  />
                </div>
                {error !== "" ? (
                  <>
                    <label
                      htmlFor="farmer_id"
                      className="verify_wrapper_form_label error_label invalid_id"
                    >
                      {error}
                    </label>{" "}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {viewdtl && (
        <div className={"modal " + (viewdtl ? "displayBlock" : "displayNone")}>
          <div className="modal-content">
            <div className="modal-title">
              <span className="modal-title-bold medium align-center primary">
                Transaction Details
              </span>
            </div>
            <div className="modal-content modal-body">
              <table className="summary_wrapper_table">
                <thead>
                  <tr className="summary_wrapper_table_tr table-header">
                    <th className="summary_wrapper_table_th mb-bold-text">
                      Transaction date
                    </th>
                    <th className="summary_wrapper_table_th mb-bold-text">
                      Product Code
                    </th>
                    <th className="summary_wrapper_table_th mb-display-none">
                      Quantity
                    </th>
                    <th className="summary_wrapper_table_th mb-bold-text">
                      Region Price
                    </th>
                    <th className="summary_wrapper_table_th mb-bold-text">
                      Unit price
                    </th>
                    <th className="summary_wrapper_table_th mb-bold-text">
                      Transaction Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {modalProps.length ? (
                    modalProps.map((txn, i) => (
                      <tr key={i} className="summary_wrapper_table_tr">
                        <td className="summary_wrapper_table_td mobile-word-wrap">
                          {format(
                            new Date(txn.datecreated.replace("Z", "")),
                            "dd-MM-yyyy hh:mm:ss"
                          )}
                        </td>
                        <td className="summary_wrapper_table_td mobile-word-wrap">
                          {txn.productCode}
                        </td>
                        <td className="summary_wrapper_table_td mb-display-none mobile-word-wrap">
                          {txn.transactionQuantity}
                        </td>
                        <td className="summary_wrapper_table_td mobile-word-wrap">
                          {currencyFormatter(txn.regionPrice)}
                        </td>
                        <td className="summary_wrapper_table_td mobile-word-wrap">
                          {currencyFormatter(txn.transactionPrice/txn.transactionQuantity)}
                        </td>
                        <td className="summary_wrapper_table_td mobile-word-wrap">
                          &nbsp;
                          {currencyFormatter( txn.transactionPrice  )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="summary_wrapper_table_tr"></tr>
                  )}
                </tbody>
              </table>
            </div>
            


            <div className="summary_wrapper_success">
                        <button onClick={(e) => { e.preventDefault(); exportReceipt(rowid) }} className="verify_wrapper_form_btn_verify select back">
                            DOWNLOAD RECEIPT
                        </button>
                        <button onClick={(e) => { e.preventDefault(); viewTransaction(false); }} className={`verify_wrapper_form_btn_verify select next`}>
                            OK
                        </button>
                    </div>





          </div>
        </div>
      )}
    </div>
  );
}

export const totalAmount = (arr) => {
  let total = 0;
  arr.forEach((obj) => {
    total += Number(obj.transactionPrice);
  });
  return total;
};

export const tdt = (data) => {
  if (data.length > 0)
    data.map((row, keys) => {
      row.qty = row.details.length;
      row.el = "...View";
      row.transactionAmtTotal = currencyFormatter(row.transactionAmtTotal);
      row.transactionDate = format(
        new Date(row.transactionDate.replace("Z", "")),
        "dd-MM-yyyy hh:mm:ss"
      );
    });

  return data;
};

export const transDt = (data) => {
  if (data.length > 0)
    data.map((row, keys) => {
      row.id = row.ID;
      row.transactionDate = format(new Date(row.TRANSACTIONDATE.replace("Z", "")), "dd-MM-yyyy hh:mm:ss");
      row.transactionReference = row.REF_NUMBER;
      row.farmername = row.FIRSTNAME + ' ' + row.LASTNAME + ' ' + row.ID_NUMBER
      row.phonenumber = row.PHONENUMBER
      row.walletname = row.WALLET_NAME
      row.qty = "5";
      row.transactionAmtTotal = currencyFormatter(row.TRANSACTIONAMOUNTTOTAL);
      row.el = '';
      row.accountNumber = row.ACCOUNT_NUMBER
      row.walletReferenceCode = row.WALLET_REFERENCE_CODE

    });

  return data;
};


export const printerD = (a, b, c, d) => {};
export const escaped = (htmlStr) => {

  htmlStr = htmlStr.replace(/&lt;/g , "<");	 
  htmlStr = htmlStr.replace(/&gt;/g , ">");     
  htmlStr = htmlStr.replace(/&quot;/g , "\"");  
  htmlStr = htmlStr.replace(/&#39;/g , "\'");   
  htmlStr = htmlStr.replace(/&amp;/g , "&");
  return htmlStr;    

}

export const Toaster = (type, message) => {
  switch (type) {
    case 'error':
      return toast.error(message, { position: "top-center", toastId: "mytoastid", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light" });
      break
    case 'success':
      return toast.success(message, { position: "top-center", toastId: "mytoastid", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light" });
      break
    case 'info':
      return toast.info(message, { position: "top-center", toastId: "mytoastid", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light" });
      break
    default:
      return toast(message, { position: "top-center", toastId: "mytoastid", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "light" });
      break;

  }
    
 
  
}
export default ViewTransactions;
